function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "14345148-D62A-4D34-AEB2-AF4384EE4CA8");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FOOTER_DESKTOP",
  transform: "translate(-194.000000, -32.000000)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-38",
  transform: "translate(194.000000, 33.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-36"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.888228, 0.434483)",
  id: "Combined-Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.59214643,20.2246105 C2.87367,22.125347 0.472842089,25.5544135 0,31.6551724 C1.24281403,28.8071862 3.72468866,26.1237901 7.10165071,24.5230437 C9.94184076,30.079935 15.7435143,33.8896544 22.4339655,33.8896552 C26.7470781,33.8896552 30.69082,32.3068639 33.7098692,29.692859 L30.5978178,23.3661358 C28.6706731,25.7294576 25.7286113,27.2406414 22.4339655,27.2406414 C18.9574812,27.2406414 15.8736462,25.5580915 13.9604734,22.9671924 C24.0347961,22.0577942 26.0307037,15.6719861 25.6039419,10.9862069 C23.6181311,15.7633924 17.2786709,17.6142091 12.0613612,17.999179 C12.0398155,18.0007622 12.0181681,18.0024043 11.9964207,18.0041066 C11.9495902,17.6037389 11.925514,17.1964922 11.925514,16.7836818 C11.925514,11.0850718 16.5136869,6.44789428 22.2121793,6.33022605 L19.0966079,1.77635684e-15 C11.2029427,1.54720589 5.24375765,8.47719351 5.24375743,16.7836818 C5.24375743,17.962184 5.36371924,19.1129736 5.59214643,20.2246105 Z"
}))))));

var SvgEroskiClub = function SvgEroskiClub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiClub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-club.0d2b2b04.svg";
export { ForwardRef as ReactComponent };